import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
// Our restyles
import './DayPicker.scss';

export default DayPicker;
